import { getEnv } from '@/constants';

export function getStreamingLocation(): string {
  return getEnv('VUE_APP_MEDIASTORE_CDN_URL_v2');
}
